import { render, staticRenderFns } from "./ShipmentCreateEditModal.vue?vue&type=template&id=204eb6d0&scoped=true&"
import script from "./ShipmentCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204eb6d0",
  null
  
)

export default component.exports